<template>
  <div class="ads-negative-prod">
    <div class="header-box">
      <el-button type="primary" size="small" id="addNewProd"  @click="dialogAddNewVisible=true">新增否定商品</el-button>
    </div>
    <el-table :data="tableData" border size="mini" style="width: 100%" cell-class-name="table-cell"
      row-class-name="table-row" header-cell-class-name="table-header-cell">
      <el-table-column type='index' label="序号" align="center">
      </el-table-column>
      <el-table-column prop="asin" label="asin">
      </el-table-column>
      <el-table-column label="商品">
        <template v-slot="img">
          <el-image
            style="width: 55px;"
            :src="img.row.imageUrl"
            fit="cover">
          </el-image>
        </template>

      </el-table-column>
      <el-table-column prop="productUrl" label="商品链接">
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click.native.prevent="onDeleteClick(scope.$index, tableData)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="新增否定商品" :visible.sync="dialogAddNewVisible" @close="onDialogAddNewClose" width="26%">
      <el-form :model="addNewForm">
        <el-form-item label="否定商品Asin" :label-width="formLabelWidth">
          <el-input v-model="addNewForm.asin" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="onDialogAddNewClose">取 消</el-button>
        <el-button type="primary" @click="onDialogAddNewConfirm('addNewForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { adsModules } from '@r'
export default {

  data () {
    return {
      tableData: [],
      dialogAddNewVisible: false,
      addNewForm: {
        asin: ''
      },
      formLabelWidth: '120px',
      campaignsId: null,
      groupId: null,
      requestType: null,
      addStatus: false
    }
  },
  created () {

  },
  activated(){
    this.campaignsId = this.$route.query.campaignsId;
    this.groupId = this.$route.query.groupId;
    this.requestType = this.$route.query.type;
    this.queryAdsList()
  },
  methods: {
    queryAdsList () {
      adsModules.getNegativeProductList({
        requestType: this.requestType,
        params:{
          beginIndex: this.beginIndex,
          pageSize: this.pageSize,
          campaignId: this.campaignsId,
          groupId: this.groupId
        }
      }).then((res) => {
        if(res.result !== 1){
          this.$message({
            type: 'error',
            message: res.message ? res.message : '列表获取出错'
          });
          return;
        }
        this.tableData = res.ldata;
      }).catch((err) => {
        this.$message({
          type: 'error',
          message: err.message ? err.message : '列表获取出错'
        });
      })
    },
    onDeleteClick (index, rows) {
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adsModules.deleteNegativeProduct({
          requestType: this.requestType,
          campaignId: this.campaignsId,
          groupId: this.groupId,
          id: rows[index].id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          rows.splice(index, 1)
        }).catch((err) => {
          console.log(err);
          this.$message({
              type: 'error',
              message: err.message ? err.message : '删除出错'
            });
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    onDialogAddNewClose () {
      this.addNewForm = {
        negativeKey: '',
        negativeType: 1
      }
      this.dialogAddNewVisible = false;
    },
    onDialogAddNewConfirm (data) {
      if(this.addStatus == true){
        return;
      }
      this.addStatus = true;
      this.dialogAddNewVisible = false;
      adsModules.insertNegativeProduct({
        requestType: this.requestType,
        campaignId: this.campaignsId,
        groupId: this.groupId,
        asin: encodeURI(this.addNewForm.asin)
      }).then((res) => {
        this.addStatus = false;
        this.$message({
          type: 'success',
          message: '新增成功!'
        });
        this.queryAdsList();
      }).catch((err) => {
        this.addStatus = false;
        this.$message({
            type: 'error',
            message: err.message ? err.message : '错误'
          });
      });
      
    }
  }
}
</script>

<style lang="scss">
  .ads-negative-prod{

    .header-box{
      text-align: left;
      padding-left: 0px;

      #addNewProd{
        width: auto;
      }
    }
    .el-input{
      width: 300px;
    }
  }
</style>
